const base_url = {
  // api1: "https://warrantyapi.amcrest.com",
  // api1: "http://143.198.181.191:8008",
  api1: "https://amcrestapis.odisoft.in",
};
export default base_url;